export const moduleName = 'chatDetails'
